// Redux Actions Types
import { SET_CONTEXT } from './types';
import Context from '../../dataAccess/ContextAccess';
import { createClassName, addStylesToHead } from '../../utilities/customStyles';
import MasterAccess from '../../dataAccess/MasterAccess';

export const setContext = payload => ({
  type: SET_CONTEXT,
  payload,
});

const sanitizeApiCss = (cssText) => {
  if (!cssText) return cssText;

  let css = cssText;

  // Fix: https: //  -> https:// inside url()
  css = css.replace(/url\(\s*(https?:)\s*\/\/\s*([^)]+)\)/gi, (_, proto, rest) => {
    const cleaned = rest.replace(/\s+/g, '');
    return `url("${proto}//${cleaned}")`;
  });

  // Fix: double closing braces }}
  css = css.replace(/}\s*}/g, '}');

  // Fix: duplicate !important !important
  css = css.replace(/!important\s*!important/g, '!important');

  // Fix: "2x" -> "2px" (common typo in your file)
  css = css.replace(/\b(\d+)x\b/g, '$1px');

  // Optional: ensure missing semicolon before }
  css = css.replace(/([^;{}])\s*}/g, '$1;}');

  return css;
};

export const fetchContext = () => (dispatch) => {
  Context.get().then((context) => {
    let triskeleCss = '';

    Promise.all([MasterAccess.getAllProperties(),
      MasterAccess.getAllMeasures(),
      MasterAccess.getUserRightsAccess(),
      MasterAccess.getAllUnits()])
      .then((response) => {
        let properties = [];
        let measurements = [];
        let userRightsAccess = [];
        let units = [];
        if (response[0].data && response[0].data.length > 0) {
          properties = response[0].data;
          context.properties = properties;
        }
        if (response[1].data && response[1].data.length > 0) {
          measurements = response[1].data;
          context.measurements = measurements;  

        }
        if (response[2].data && response[2].data.length > 0) {
          userRightsAccess = response[2].data;
          context.userRightsAccess = userRightsAccess;

        }
        if (response[3].data && response[3].data.length > 0) {
          units = response[3].data;
          context.units = units;  

        }

        Context.save(context).then(() => console.log('New Context Saved'));
        context.properties.forEach((property) => {
          let classname = createClassName('.', property);


          property.VisualProperties = property.VisualProperties ? property.VisualProperties : property.VisualPropertys;
          classname = classname.replace('&', 'And');
          if (property.VisualProperties) {
            const classValue = property.VisualProperties.replace(/;/g, ' !important;');
            triskeleCss += `${classname}${classValue} `;
          }
        });

        triskeleCss = sanitizeApiCss(triskeleCss);
        addStylesToHead(triskeleCss);
        dispatch(setContext(context));
      });
  });
};

